export default __webpack_public_path__ + "static/media/Screenshot (53).7d074480.png";